import React from 'react';
import PropTypes from 'prop-types';

import './RSVPPage.css';

export default class LoginForm extends React.Component {
  static propTypes = {
    firebase: PropTypes.object.isRequired,
  };

  onLogin = () => {
    const { firebase } = this.props;
    firebase.login({
      provider: 'facebook',
      type: 'redirect',
    });
  };

  render() {
    return (
      <div className="row">
        <div className="col-xs-offset-1 col-xs-10">
          <button className="button facebook-login" onClick={this.onLogin}>
            Login with Facebook
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RSVPPage/LoginForm.js